import qualificationService from '@/services/QualificationService';
import type { Qualification } from '@/types/Qualification';

export default function useGetQualifications() {
  const qualifications = ref<Qualification[]>([]);
  const loading = ref(false);

  const getQualifications = async (): Promise<Qualification[]> => {
    if (loading.value) return qualifications.value;

    qualifications.value = [];
    loading.value = true;

    const { data } = await qualificationService.getQualifications();

    loading.value = false;
    qualifications.value = data.value || [];

    return qualifications.value;
  };

  return {
    qualifications,
    loading,
    getQualifications,
  };
}
